<ng-container *ngFor="let link of emailConfigData">
  <a
    class="btn btn-link"
    href="javascript:void(0)"
    (click)="openEmailClient(link.emailConfig)"
    (keydown.enter)="openEmailClient(link.emailConfig)"
    tabindex="0"
  >
    {{ link.name }}
  </a>
</ng-container>
